export default "__VITE_ASSET__BSHILLOn__"